import { Col, Modal, Pagination, Row, Space, Spin, Table, Tag } from 'antd';
import React, { useEffect, useState } from 'react';
import { EyeOutlined, DownloadOutlined } from '@ant-design/icons';
import { TripsFilter } from './TripsFilter';
import { useSortedTripsTaxiQuery } from '../hooks/useSortedTripsTaxiQuery';
import { useCurrentTrip } from '../hooks/useCurrentTrip';
import TripsViewModal from './TripsViewModal';
import { convertDateToFormat } from '../../../shared/Utils';

const TripsTaxiTable = () => {
    const { sortedTrips: trips, refetch, loading, ...pagination } = useSortedTripsTaxiQuery();
    const [isViewModalVisible, setViewModalVisible] = useState(false);
    const { setCurrentTrip } = useCurrentTrip();

    const [tripId, setTripId] = useState(null);

    const handleViewTrip = (trip) => {
        setCurrentTrip(trip);
        setTripId(trip._id);
        setViewModalVisible(true);
    };

    const columns = [
        {
            title: 'ID',
            dataIndex: 'logicalId',
            key: 'logicalId',
            sorter: (a, b) => a.logicalId - b.logicalId,
            width: 80,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            width: 100,
        },
        {
            title: 'Start date',
            dataIndex: 'createdDate',
            key: 'createdDate',
            width: 150,
            sorter: (a, b) => a.createdDate - b.createdDate,
            render: (text, record) => {
                return convertDateToFormat(record.createdDate, 'DD-MM-YYYY, HH:mm');
            },
        },
        {
            title: 'Rider name',
            dataIndex: 'passengerId',
            key: 'passengerId',
            width: 100,
            render: (_, record) => record?.passengerId?.fullName,
        },
        {
            title: 'Action',
            key: 'action',
            width: 100,
            render: (_, trip) => (
                <Space size="middle">
                    <a href="#" onClick={() => handleViewTrip(trip)}>
                        <EyeOutlined />
                    </a>
                </Space>
            ),
        },
    ];

    const Paginator = () => (
        <Row justify={'center'}>
            <Col>
                <Pagination
                    size="default"
                    total={pagination.totalCount}
                    pageSize={pagination.pageSize}
                    current={pagination.page}
                    showTotal={(total) => `Total Trips ${total}`}
                    onChange={(newPage) => pagination.setPage(newPage)}
                    showQuickJumper={true}
                    showSizeChanger={false}
                    showLessItems={false}
                />
            </Col>
        </Row>
    );

    return (
        <>
            {isViewModalVisible && <TripsViewModal isOpen={isViewModalVisible} onRequestClose={setViewModalVisible} />}

            <div style={{ flex: '1 1 auto' }}>
                <Row gutter={[16, 6]} style={{ paddingBottom: 10, paddingTop: 20 }}>
                    <TripsFilter />
                </Row>
                <Row gutter={16} style={{ paddingBottom: 10, paddingTop: 10 }}>
                    <Col xs={24}>
                        <Spin spinning={loading}>
                            <Table
                                dataSource={trips}
                                columns={columns}
                                pagination={false}
                                rowKey={() => Math.random().toString()}
                                scroll={{ x: 1500 }}
                            ></Table>
                        </Spin>
                    </Col>
                </Row>
                <Paginator />
            </div>
        </>
    );
};

export default TripsTaxiTable;
